export const showReadonlyObjectErrorMessage = (dispatch) => {
	dispatch({ type: "SHOW_ERROR_MESSAGE", data: "This object is marked as read-only" });
};
